import { getObject, postObject, postVoid, ErrorCallbackFunction } from '../ChoiceApi';

export type PrescriptionTypeValues = "Change" | "Refill" | "Prescription" | undefined
export interface PrescriptionAndTypeModel
{
    prescriptionId: number, 
    prescriptionType: PrescriptionTypeValues
} 

export async function RxDecline(prescriptionInfo: PrescriptionAndTypeModel[] | PrescriptionAndTypeModel, errorCallback?: ErrorCallbackFunction) : Promise<void>
{
    if (Array.isArray(prescriptionInfo))
        await postVoid("/api/EMR/Prescription/Rx/Decline", prescriptionInfo);
    else
        await postVoid("/api/EMR/Prescription/Rx/Decline", [prescriptionInfo]);

}

export async function RxCancel(prescriptionInfo: PrescriptionAndTypeModel[] | PrescriptionAndTypeModel) : Promise<void>
{
    if (Array.isArray(prescriptionInfo))
        await postVoid("/api/EMR/Prescription/Rx/Cancel", prescriptionInfo);
    else
        await postVoid("/api/EMR/Prescription/Rx/Cancel", [prescriptionInfo]);
}

export async function RxApprove(request: RxApprovalRequest) : Promise<RxApprovalRespModel[] | undefined>
{
    return await postObject("/api/EMR/Prescription/Rx/Approve", request);
}

export async function getMedicationDispenseInfo() : Promise<IMedicationDispenseInfoModel[] | undefined>
{
    return await getObject("/api/EMR/Prescription/Medication/Dispense/Info");
}

export interface RxApprovalRequest
{
    prescriptions: PrescriptionItemModel[],
    signatureMode: "MessageSignatureModes.IdMe"
}

export interface PrescriptionItemModel
{
    prescriptionId: number, 
    prescriptionType?: PrescriptionTypeValues, 
    rxRefNumber?: string,
    refilResponseCode?: string,
    serviceLevelDesc?: string,
    epcsDataXml?: string,
    messageForSignature?: string
}

export interface RxApprovalRespModel
{
    prescriptionId:number,
    success?: string,
    errorMsg?: string
}

export interface IMedicationDispenseInfoModel
{
    dispense_code: number,
    shortDescription?: string,
    quantityUnitOfMeasureCode_NCLT?: string,
    defaultUnitOfMeasureForCode: boolean
}